import React from 'react'
import { Formik } from 'formik'

import { Button, Form, Modal } from '_zari/core'
import { ZariContext } from '_zari/context'
import Yup from '_zari/validation/_yup'

import * as ProductoCrud from 'services/producto.service'

import CodigoFormGroup from './formGroups/codigo'
import NombreFormGroup from './formGroups/nombre'

export const ValidationSchema = Yup.object().shape({
  nombre: Yup.string()
    .min(2)
    .max(200)
    .required(),
  codigo: Yup.string()
    .min(3)
    .max(15)
    .required()
})

const GenerarCopiaModal = ({ handleClose, show, modalData, reloadTable }) => {
  const __zariContext = React.useContext(ZariContext)
  const formInitialValues = React.useMemo(
    () => ({
      codigo: '',
      codigoGeneradoFlag: false,
      nombre: modalData.nombre || ''
    }),
    [modalData]
  )

  const submitHandler = async data => {
    await ProductoCrud.generarCopia(modalData._id, data)
      .then(() => {
        __zariContext.snack('success', 'El registro se ha copiado.')
        reloadTable()
        handleClose()
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }

  return (
    <Modal show={show} onHide={handleClose} size='sm'>
      <Modal.Header>
        <Modal.Title>COPIAR PRODUCTO</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
        {({ errors, handleSubmit, isSubmitting, setValues, touched, values, handleChange }) => (
          <Form>
            <Modal.Body>
              <CodigoFormGroup
                iError={errors.codigo}
                iTouched={touched.codigo}
                fIsSubmitting={isSubmitting}
                values={values}
                setValues={setValues}
                handleChange={handleChange}
              />
              <NombreFormGroup iError={errors.nombre} iTouched={touched.nombre} fIsSubmitting={isSubmitting} />
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>Generar Copia</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default GenerarCopiaModal
